import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Layout from '../../layout/layout';
import SuggestionList from './SuggestionList';
import SuggestionCreate from './SuggestionCreate';
import { Box } from '@mui/material';

const SuggestionRoutes = ({ toggleTheme }) => {
  const navigate = useNavigate();

  return (
    <Layout pageType="sideBar" toggleTheme={toggleTheme}>
      <Box ml={2}>
        <Routes>
          {/* LIST */}
          <Route
            index
            element={
              <SuggestionList
                toggleTheme={toggleTheme}
                onCreate={() => navigate('create')}
              />
            }
          />

          {/* CREATE */}
          <Route
            path="create"
            element={
              <SuggestionCreate
                feedbackType={1}
                onCancel={() => navigate('/suggestions')}
                onSuccess={() => navigate('/suggestions')}
              />
            }
          />

          {/* FALLBACK */}
          <Route path="*" element={<Navigate to="" replace />} />
        </Routes>
      </Box>
    </Layout>
  );
};

export default SuggestionRoutes;
